import moment from "moment"
import React from "react"
import { Button } from "@mui/material"
import { START_ACTIVITY_TEXT, NO_ACTIVITY_AVAILABLE } from "../constants"

export const OfflineSession = ({ nextSession, canStartNextSession }) => {
  const assignmentLink = nextSession?.assignment_link || null
  const canStartSession = canStartNextSession && assignmentLink

  const handleStartSession = e => {
    e.preventDefault()
    if (canStartSession) window.open(assignmentLink, "_blank")
  }

  const getStartActivityText = () => {
    if (assignmentLink) return START_ACTIVITY_TEXT

    return NO_ACTIVITY_AVAILABLE
  }

  const getButtonText = () => {
    return canStartNextSession
      ? getStartActivityText()
      : `Can be started in ${moment(nextSession.scheduled_at).toNow(true)}`
  }

  return (
    <Button
      className={"next-lesson-data-button"}
      variant="contained"
      size="sm"
      onClick={handleStartSession}
      disabled={!canStartSession}
    >
      {getButtonText()}
    </Button>
  )
}
